<script>
    import StaticIcon from "@/components/StaticIcon";

    export default {
        name: "TheSocialLinks",
        components: { StaticIcon },
        props: {
            telegram: String,
            youtube: String,
            isHeader: Boolean,
        },
    };
</script>

<template>
    <div class="the-social-links" :class="{ 'is-header': isHeader }">
        <a v-if="telegram" class="telegram" :href="telegram" target="_blank">
            <static-icon name="telegram"></static-icon>
        </a>
        <a v-if="youtube" class="youtube" :href="youtube" target="_blank">
            <static-icon name="youtube"></static-icon>
        </a>
    </div>
</template>

<style lang="scss">
    .the-social-links {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 -6px;
        &.is-header {
            justify-content: flex-start;
        }
        @include bp($bp-desktop-sm) {
            justify-content: flex-start;
        }
        a {
            margin: 0 6px;
        }
        svg {
            width: 100%;
            height: 100%;
            transition: fill 0.2s ease-in;
        }
        a.telegram {
            @include box(28px);
            fill: #1c92ff;
            &:hover {
                svg {
                    fill: #147bda;
                }
            }
            &:active {
                svg {
                    fill: #126abc;
                }
            }
        }
        a.youtube {
            width: 34px;
            height: 24px;
            fill: #ff0000;
            &:hover {
                svg {
                    fill: #e60000;
                }
            }
            &:active {
                svg {
                    fill: #cc0000;
                }
            }
        }
    }
</style>
